import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

// Editorial image gallery with click-to-expand lightbox.
export const ImageGallery = ({ images = [], alt = "Colosseum" }) => {
  const [active, setActive] = useState(null);
  if (!images.length) return null;
  return (
    <>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3" data-testid="image-gallery">
        {images.map((src, i) => (
          <button
            key={i}
            onClick={() => setActive(src)}
            data-testid={`gallery-image-${i}`}
            className={cn(
              "group relative overflow-hidden rounded-2xl border border-stone-line focus:outline-none focus-visible:ring-2 focus-visible:ring-gold",
              i === 0 && "col-span-2 row-span-2 md:col-span-2"
            )}
          >
            <img
              src={src}
              alt={`${alt} ${i + 1}`}
              loading="lazy"
              className={cn(
                "w-full object-cover transition-transform duration-700 group-hover:scale-105",
                i === 0 ? "aspect-[4/3] md:aspect-[16/11]" : "aspect-square"
              )}
            />
          </button>
        ))}
      </div>
      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-4xl border-none bg-transparent p-0 shadow-none">
          <DialogTitle className="sr-only">Image preview</DialogTitle>
          {active && (
            <img
              src={active}
              alt={alt}
              className="w-full rounded-2xl object-contain"
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ImageGallery;
